import { IRequesterInfo } from "../../../../base/models"
import { ClientProxy } from "../../../../base/proxy/clientProxy"

export class SendDealerRejectApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'MyReports/sendDealerReject',
      requesterInfo,
    })
  }

  public async rejectDealerApproval(request: number[]): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
